import { useCurrentScreen } from "@auth0/auth0-acul-react";

import { getScreenComponent } from "@/utils/screen/screenLoader";

/**
 * Tenant-deployed screen router.
 *
 * Reads the current ACUL screen from the Auth0 React SDK's `useCurrentScreen`
 * hook (which reflects the real Universal Login context Auth0 injected) and
 * renders the matching screen component. Falls back to a "not implemented"
 * message for screen names we haven't built yet, and returns null when no
 * screen context is present yet.
 *
 * "Tenant" here means "the bundle Auth0 serves on a real tenant" — the same
 * build runs on the DEV, QA, and PROD tenant stages. The only non-tenant
 * runtime is the local Vite dev server, which uses LocalScreenManager.
 */
export default function TenantScreenManager() {
  const screenOptions = useCurrentScreen();
  const screenName = screenOptions?.screen?.name;
  const ScreenComponent = getScreenComponent(screenName);

  if (!screenName) {
    return null;
  }

  if (ScreenComponent) {
    return <ScreenComponent key={screenName} />;
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="p-2 text-center">
        <p className="text-lg text-gray-600">
          Screen &quot;{screenName}&quot; is not implemented
        </p>
      </div>
    </div>
  );
}
